module.exports = __webpack_public_path__ + "static/media/在地震發生的前一年 有沒有和家人討論地震災害的避難方法.32def6e5.png";